import React from 'react';
import { Content, Flex, Text, Button, Pane, Radio, Toast } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { TitleBar } from '@leverege/ui-plugin';
import { LoadingView } from '@leverege/molten/views';
import Detail from '../Detail';
import S from '../../PairForm.css';
import { canRemoveVehicle, unpairLocatorFromVehicle } from '../../../../util/Interface';
import { getCompanyAndLocationIdsFromUrl } from '../../../../util/Url';
import PairResult from '../../PairResult';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class VehicleElsewhere extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moveOption: null,
      loading: false,
      error: null
    };
  }
  onChangeMoveOption = ({
    data
  }) => {
    this.setState({
      moveOption: data
    });
  };
  onChangeLocation = async (evt = {}, action = 'okay', removeLocator = false, unpairReason) => {
    const {
      onOkay,
      onClose,
      location,
      selectedObject,
      actions
    } = this.props;
    const {
      vehicle
    } = selectedObject;

    // TODO: This will break if the ref of the parentItem is ever fixed in molten
    const loc = {
      ...location,
      ref: location.ref.substring(0, location.ref.lastIndexOf('/')),
      type: 'location'
    };
    const locationActions = DataSources.getActions(loc);
    const closeLoading = LoadingView.showDialog(`Moving ${vehicle?.data?.vin}...`);
    try {
      try {
        const interfaceUrl = actions.getInterfaceUrl();
        const {
          companyId
        } = getCompanyAndLocationIdsFromUrl(interfaceUrl);
        if (removeLocator) {
          await unpairLocatorFromVehicle({
            locatorId: vehicle.data.locator?.id,
            companyId,
            unpairReason
          });
        }

        // get selected vehicles location and company id to check for permission to remove a vehicle
        // so that we know that the user can create a vehicle in the new location
        const vehicleLocationId = vehicle.data?.location?.id;
        const vehicleCompanyId = vehicle.data?.company?.id;
        if (companyId) {
          await canRemoveVehicle({
            locationId: vehicleLocationId,
            companyId: vehicleCompanyId,
            vehicleId: vehicle.id
          });
        }
        await GlobalState.dispatch(locationActions.child('vehicles').create({
          id: vehicle.id,
          force: true
        }));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        throw err;
      }
      if (action === 'okay') {
        onOkay?.(evt);
      }
      if (action === 'close') {
        onClose();
      }
      closeLoading();
      Toast.success('Successfully moved vehicle');
    } catch (err) {
      closeLoading();
      this.setState({
        error: err
      });
    }
  };
  onSubmit = evt => {
    const {
      moveOption
    } = this.state;
    if (moveOption === 'moveKeepLocator') {
      this.onChangeLocation(undefined, 'close');
    } else if (moveOption === 'moveSwapLocator') {
      const reason = 'Unpaired locator when moving vehicle to a different location';
      this.onChangeLocation(undefined, undefined, true, reason);
    }
  };
  render() {
    const {
      areaClassName,
      footerClassName,
      onClose,
      selectedObject,
      titleVariant,
      titleIcon,
      assetId,
      trackerId
    } = this.props;
    const {
      error
    } = this.state || {};
    if (error) {
      const noRetry = true;
      return /*#__PURE__*/_jsx(PairResult, {
        type: "failure",
        pairing: true,
        error: error,
        areaClassName: areaClassName,
        footerClassName: footerClassName,
        onClose: onClose,
        onReset: onClose,
        titleVariant: titleVariant,
        titleIcon: titleIcon,
        assetId: assetId,
        trackerId: trackerId,
        noRetry: noRetry
      });
    }
    const {
      moveOption,
      loading
    } = this.state;
    const {
      location,
      vehicle
    } = selectedObject;
    const isPaired = vehicle?.data?.locator?.id != null;
    const headline = isPaired ? 'Vehicle Already Paired & At Another Location' : 'Vehicle at Another Location';
    const body = isPaired ? `This vehicle is currently in another location and paired to a Locator. 
      You can either move the vehicle & paired Locator to your location 
      or move just the vehicle and pair a new Locator to it.` : `This vehicle is currently in another location. 
      To move it to this location, click the override button below.`;
    const submitText = isPaired ? 'Submit' : 'Change Location & Pair';
    const submit = isPaired ? this.onSubmit : this.onChangeLocation;
    const submitDisabled = isPaired ? moveOption == null : false;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: titleVariant,
          title: "Pair Locator to Vehicle",
          icon: titleIcon,
          children: /*#__PURE__*/_jsx(Button, {
            variant: "closeDialog",
            className: S.close,
            onClick: onClose
          })
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        style: {
          maxHeight: '75vh'
        },
        className: areaClassName,
        children: /*#__PURE__*/_jsxs(Flex, {
          variant: "colL",
          children: [/*#__PURE__*/_jsx("img", {
            className: S.locatorError,
            src: isPaired ? 'https://recovr-ui-assets.storage.googleapis.com/locator-and-vehicle-elsewhere.png' : 'https://recovr-ui-assets.storage.googleapis.com/vehicle-elsewhere.png',
            alt: "Locator warning",
            height: 92,
            width: 136
          }), /*#__PURE__*/_jsx(Text, {
            variant: "formTitle",
            children: headline
          }), /*#__PURE__*/_jsx(Text, {
            children: body
          }), isPaired ? /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsxs(Flex, {
              variant: "colS",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "detailTitle",
                children: "Location"
              }), /*#__PURE__*/_jsx(Pane, {
                variant: "dashboardCard",
                children: /*#__PURE__*/_jsx(Pane, {
                  layout: "flex:col",
                  variant: "dataCard",
                  children: /*#__PURE__*/_jsx(Detail, {
                    className: S.detailPair,
                    label: "Current Location",
                    value: location?.data?.name || 'Unknown'
                  })
                })
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              variant: "colS",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "detailTitle",
                children: "Locator"
              }), /*#__PURE__*/_jsx(Pane, {
                variant: "dashboardCard",
                children: /*#__PURE__*/_jsxs(Pane, {
                  layout: "flex:col",
                  variant: "dataCard",
                  children: [/*#__PURE__*/_jsx(Detail, {
                    className: S.detailPair,
                    label: "Existing Locator ID",
                    value: vehicle?.data?.locator?.data?.serialNumber || 'Unknown'
                  }), /*#__PURE__*/_jsx(Detail, {
                    className: S.detailPair,
                    label: "Installation Location",
                    value: vehicle?.data?.locator?.data?.installLocation || 'Unknown'
                  })]
                })
              })]
            }), /*#__PURE__*/_jsxs(Flex, {
              variant: "colS",
              children: [/*#__PURE__*/_jsx(Text, {
                variant: "detailTitle",
                children: "Select Action"
              }), /*#__PURE__*/_jsx(Radio, {
                className: moveOption === 'moveKeepLocator' ? S.activeUnpairOption : S.unpairOption,
                variant: "pairing",
                eventData: "moveKeepLocator",
                label: "Move vehicle & keep existing Locator paired",
                on: "moveKeepLocator",
                value: moveOption,
                onChange: this.onChangeMoveOption
              }), /*#__PURE__*/_jsx(Radio, {
                className: moveOption === 'moveSwapLocator' ? S.activeUnpairOption : S.unpairOption,
                variant: "pairing",
                eventData: "moveSwapLocator",
                label: "Move vehicle & pair new Locator",
                on: "moveSwapLocator",
                value: moveOption,
                onChange: this.onChangeMoveOption
              })]
            })]
          }) : /*#__PURE__*/_jsx(Pane, {
            variant: "dashboardCard",
            children: /*#__PURE__*/_jsx(Pane, {
              layout: "flex:col",
              variant: "dataCard",
              children: /*#__PURE__*/_jsx(Detail, {
                className: S.detailPair,
                label: "Current Location",
                value: location?.data?.name || 'Unknown'
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Content.Footer, {
        className: footerClassName,
        layout: "flex:rowMEnd",
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: onClose,
          variant: "secondary",
          children: "Cancel"
        }), /*#__PURE__*/_jsx(Button, {
          variant: "primary",
          "data-test-id": "button.pairing.pairLocatorToVehicleDiffLocation",
          disabled: submitDisabled || loading,
          onClick: submit,
          children: submitText
        })]
      })]
    });
  }
}